
import { CyclePhase } from './types';

// Generate recommendations based on cycle phase
export function getPhaseRecommendations(phase: CyclePhase): string[] {
  switch (phase) {
    case 'menstrual':
    case 'menstruation':
      return [
        'Focus on rest and self-care',
        'Avoid intense workouts; try gentle yoga or walking',
        'Stay hydrated and warm',
        'Iron-rich foods can help replenish lost nutrients',
        'Consider mindfulness practices to manage discomfort'
      ];
    case 'follicular':
      return [
        'Great time to start new projects',
        'Energy is increasing; try moderate intensity workouts',
        'Focus on building strength and endurance',
        'Socialize and connect with others',
        'Antioxidant-rich foods support follicular health'
      ];
    case 'ovulatory':
    case 'ovulation':
      return [
        'Energy levels are typically at their highest',
        'Good time for high-intensity workouts',
        'Communication skills peak during this phase',
        'Focus on presentations or important conversations',
        'Stay hydrated as metabolism increases'
      ];
    case 'luteal':
      return [
        'Start winding down high-intensity activities',
        'Focus on completing projects rather than starting new ones',
        'Practice stress management techniques',
        'Emphasize foods rich in B vitamins and magnesium',
        'Schedule time for reflection and planning'
      ];
    case 'premenstrual':
      return [
        'Prioritize self-care and rest',
        'Gentle movement like walking or stretching',
        'Minimize caffeine and alcohol',
        'Practice stress reduction techniques',
        'Focus on magnesium-rich foods to help with mood and cramps'
      ];
    default:
      return ['Loading recommendations...'];
  }
}

// Generate insights based on current phase and symptoms
export function getCycleInsights(phase: CyclePhase, symptoms: string[] = []): string {
  const baseInsight = `You're currently in your ${phase} phase. `;
  
  switch (phase) {
    case 'menstrual':
    case 'menstruation':
      return baseInsight + 'During this time, your hormone levels are at their lowest, which may explain any fatigue or low energy you might be experiencing. Focus on rest and gentle movement.';
    case 'follicular':
      return baseInsight + 'Your estrogen is rising, which often brings increased energy and creativity. This is a great time to start new projects or increase workout intensity.';
    case 'ovulatory':
    case 'ovulation':
      return baseInsight + 'Estrogen peaks during ovulation, which can boost your mood and energy levels. Many women feel their most confident and sociable during this phase.';
    case 'luteal':
      return baseInsight + 'Progesterone rises during this phase, which may create a sense of calm and focus. You might notice increased appetite or food cravings as your body uses more calories.';
    case 'premenstrual':
      return baseInsight + 'Both estrogen and progesterone decrease during this phase, which may affect your mood and energy. Practice self-compassion and focus on stress-reducing activities.';
    default:
      return 'We need more information to provide personalized insights. Please update your cycle data.';
  }
}
